'use strict';

const isMobileOrTabletWidth = require('./modules/util/isMobileOrTabletWidth');
const appendParamToURL = require('./modules/util/appendParamToURL');
const damHelper = require('./dam/dam-helper');

let currentQuery = null;
let lastQuery = null;
let runningQuery = null;
const delay = 30;
const $suggestionsContainer = $('.js-search-suggestions-container');
const $searchResultsContainer = $('.js-search-results-holder');
const $searchQuickLinksDiv = $('.js-search-quick-links');
const $searchInputField = $('.js-search-input-field');
let suggestionsTotal = $searchQuickLinksDiv.find('a').length;
let selectedSuggestionIdx = - 1;
let suggestionsElementsList = $searchQuickLinksDiv.find('a');
const gtm = require('./modules/google').tagManager;

/**
 * @function
 * @description Handles keyboard's arrow keys
 * @param keyCode Code of an arrow key to be handled
 */
function handleArrowKeys(keyCode) {
    switch (keyCode) {
        case 38:
            // keyUp
            selectedSuggestionIdx = (selectedSuggestionIdx == -1) ? (suggestionsTotal - 1) : (selectedSuggestionIdx - 1);
            break;
        case 40:
            // keyDown
            selectedSuggestionIdx = (selectedSuggestionIdx >= suggestionsTotal - 1) ? -1 : selectedSuggestionIdx + 1;
            break;
        default:
            // reset
            selectedSuggestionIdx = -1;
            return false;
    }

    if (selectedSuggestionIdx === -1){
        $searchInputField.focus();
    } else {
        suggestionsElementsList.eq(selectedSuggestionIdx).focus();
    }

    return true;
}

const searchsuggest = {
    /**
     * @function
     * @description Configures parameters and required object instances
     */
    init: function () {

        $(document).on('click', '.product-link', function () {
            const clickTarget = $(this).find('.js-search-suggestion-name').text();
            gtm.pushDataLayerEvent({
                event: 'search',
                search_term: $($searchInputField).val() ? $($searchInputField).val().toLowerCase() : '',
                search_type: 'suggestion',
                click_target: clickTarget ? clickTarget.replace(/^\s+|\s+$/g, '').toLowerCase() : ''
            });
        });

        $(document).on('click', '.js-search-quick-links a', function () {
            gtm.pushDataLayerEvent({
                event: 'search',
                search_term: null,
                search_type: 'suggestion',
                click_target: $(this).text() ? $(this).text().toLowerCase() : ''
            });
        });

        $(document).on('click', '.js-search-view-all-link', function () {
            gtm.pushDataLayerEvent({
                event: 'search',
                search_term: $($searchInputField).val() ? $($searchInputField).val().toLowerCase() : '',
                search_type: 'input',
                click_target: 'view all products'
            });
        });

        // on key up listener
        $searchInputField.keyup(function (e) {

            // get keyCode (window.event is for IE)
            const keyCode = e.keyCode || window.event.keyCode;

            // check and treat up and down arrows
            if (handleArrowKeys(keyCode)) {
                return;
            }
            if (keyCode === 13) {
                gtm.pushDataLayerEvent({
                    event: 'search',
                    search_term: $($searchInputField).val() ? $($searchInputField).val().toLowerCase() : '',
                    search_type: 'input',
                    click_target: null
                });
            }
            // check for an ENTER or ESC
            if (keyCode === 13 || keyCode === 27) {
                this.clearResults();
                return;
            }

            currentQuery = $searchInputField.val().trim();

            // no query currently running, init an update
            if (!runningQuery) {
                runningQuery = currentQuery;
                setTimeout(this.suggest.bind(this), delay);
            }
        }.bind(this));

        $suggestionsContainer.keyup(function(e){
            // get keyCode (window.event is for IE)
            const keyCode = e.keyCode || window.event.keyCode;

            // check and treat up and down arrows
            if (handleArrowKeys(keyCode)) {
                return;
            }
        });
    },

    /**
     * @function
     * @description trigger suggest action
     */
    suggest: function () {
        const headermenu = require('./header-menu');
        // check whether query to execute (runningQuery) is still up to date and had not changed in the meanwhile
        // (we had a little delay)
        if (runningQuery !== currentQuery) {
            // update running query to the most recent search phrase
            runningQuery = currentQuery;
        }

        // if it's empty clear the results box and return
        if (runningQuery.length === 0) {
            this.clearResults();
            runningQuery = null;
            return;
        }

        // if the current search phrase is the same as for the last suggestion call, just return
        if (lastQuery === runningQuery) {
            runningQuery = null;
            return;
        }

        // build the request url
        const reqUrl = appendParamToURL(Urls.searchsuggest, 'q', runningQuery);

        // execute server call
        $.get(reqUrl, function (data) {
            const suggestionHTML = data,
                ansLength = suggestionHTML.trim().length;

            // if there are results populate the results div
            if (ansLength === 0) {
                this.clearResults();
            } else {
                // update the results div
                $searchResultsContainer.html(suggestionHTML).fadeIn(200);
                damHelper.updateImages($searchResultsContainer);
                $searchQuickLinksDiv.hide();

                if (!isMobileOrTabletWidth()) {
                    $searchResultsContainer.find('a').last().on('blur', function() {
                        headermenu.closeSearchBar();
                    });
                } else {
                    $searchResultsContainer.find('a').last().on('keydown', function (e) {
                        if (e.which == 9 && !e.shiftKey) {
                            e.preventDefault();
                            $('.js-close-search-bar').focus();
                        }
                    });
                }
            }

            // get suggestions elements list
            if ($searchQuickLinksDiv.is(':visible')){
                // if quick links are visible count those instead
                suggestionsElementsList = $searchQuickLinksDiv.find('a');
            } else {
                // if results container is there make a list of those
                suggestionsElementsList = $searchResultsContainer.find('a');
            }

            selectedSuggestionIdx = -1;
            suggestionsTotal = suggestionsElementsList.length;

            // record the query that has been executed
            lastQuery = runningQuery;
            // reset currently running query
            runningQuery = null;

            // check for another required update (if current search phrase is different from just executed call)
            if (currentQuery !== lastQuery) {
                // ... and execute immediately if search has changed while this server call was in transit
                runningQuery = currentQuery;
                setTimeout(this.suggest.bind(this), delay);
            }

        }.bind(this));
    },
    /**
     * @function
     * @description
     */
    clearResults: function () {
        if (!$searchResultsContainer) { return; }
        $searchResultsContainer.fadeOut(200, function () {
            $searchResultsContainer.empty();
            $searchQuickLinksDiv.show();
        });

        selectedSuggestionIdx = -1;
        suggestionsElementsList = $searchQuickLinksDiv.find('a');
        suggestionsTotal = suggestionsElementsList.length;
    }
};

module.exports = searchsuggest;
